import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "../styles/layout.css";

export default function BackButton({ label = "← Back", className = "" }) {
  const navigate = useNavigate();
  const location = useLocation();

  const handleClick = () => {
    const segments = location.pathname.split("/").filter(Boolean);

    if (segments.length === 0) {
      navigate("/");
      return;
    }

    const last = segments[segments.length - 1];
    const secondLast = segments[segments.length - 2];

    // 🔹 Case: /module/create → /module
    if (last === "create") {
      navigate("/" + segments.slice(0, -1).join("/"));
      return;
    }

    // 🔹 Case: /module/edit/:id → /module
    if (secondLast === "edit") {
      navigate("/" + segments.slice(0, -2).join("/"));
      return;
    }

    // 🔹 Default: go one level up
    navigate("/" + segments.slice(0, -1).join("/"));
  };

  return (
    <button
      className={`back-button ${className}`}
      onClick={handleClick}
    >
      {label}
    </button>
  );
}
